import { LegacyMigrationMessages, TranslationLegacyMigrationMessages } from "./interfaces";

export const messages: TranslationLegacyMigrationMessages = {
  [LegacyMigrationMessages.legacyMigrationTitle]: "Migração do legado",
  [LegacyMigrationMessages.legacyMigrationNotConfigured]:
    "A migração não está configurada neste ambiente. {{problem}}",
  [LegacyMigrationMessages.legacyMigrationForbidden]:
    "Você não tem acesso à migração do legado. Peça a quem gerencia o acesso.",
  [LegacyMigrationMessages.legacyMigrationSessionExpired]:
    "Sua sessão expirou. Entre novamente para continuar.",

  [LegacyMigrationMessages.legacyMigrationStepCustomer]: "Cliente",
  [LegacyMigrationMessages.legacyMigrationStepReview]: "Revisão",

  [LegacyMigrationMessages.legacyMigrationChooseTitle]: "Qual cliente você vai migrar?",
  [LegacyMigrationMessages.legacyMigrationSearchTenant]: "Buscar cliente",
  [LegacyMigrationMessages.legacyMigrationNoTenants]: "Nenhum cliente com esse nome.",
  [LegacyMigrationMessages.legacyMigrationTenantsUnavailable]:
    "Não foi possível carregar a lista de clientes.",
  [LegacyMigrationMessages.legacyMigrationInactiveTenant]: "inativo",
  [LegacyMigrationMessages.legacyMigrationStart]: "Iniciar migração",

  [LegacyMigrationMessages.legacyMigrationReadingTitle]: "Lendo os usuários de {{tenant}}…",
  [LegacyMigrationMessages.legacyMigrationReadingHint]:
    "Estamos lendo a base do CRM antigo. Leva alguns segundos e nada é alterado lá.",

  [LegacyMigrationMessages.legacyMigrationReviewTitle]: "{{count}} usuários de {{tenant}} serão migrados",
  [LegacyMigrationMessages.legacyMigrationSearchUser]: "Buscar e-mail ou nome",
  [LegacyMigrationMessages.legacyMigrationSelectAll]: "Marcar todos",
  [LegacyMigrationMessages.legacyMigrationClearAll]: "Desmarcar todos",
  [LegacyMigrationMessages.legacyMigrationColumnUser]: "Usuário",
  [LegacyMigrationMessages.legacyMigrationColumnPassword]: "Senha",
  [LegacyMigrationMessages.legacyMigrationColumnModules]: "Módulos",
  [LegacyMigrationMessages.legacyMigrationPasswordKept]: "mantém a senha (MAIÚSCULAS)",
  [LegacyMigrationMessages.legacyMigrationPasswordReset]: "vai receber e-mail",
  [LegacyMigrationMessages.legacyMigrationPasswordKeptHint]:
    "No Topcon Suite, a senha deve ser digitada com as letras em MAIÚSCULAS, como o Topcon Legado a guarda.",
  [LegacyMigrationMessages.legacyMigrationPasswordWeakHint]:
    "A senha do Topcon Legado não atende as regras do Topcon Suite (8 a 64 caracteres, com letras, números e símbolo). "
    + "O usuário recebe um e-mail para criar uma nova.",
  [LegacyMigrationMessages.legacyMigrationLockNeedsKeptPassword]:
    "Só dá para bloquear quando a senha do Topcon Legado é mantida. Sem ela, o usuário ficaria sem acesso aos dois sistemas "
    + "até criar a senha pelo e-mail.",
  [LegacyMigrationMessages.legacyMigrationNotContractedBanner]:
    "Não contratado para {{tenant}}: {{modules}}. Contrate no Tenant Manager antes de migrar; quem só tem esse módulo "
    + "não recebe acesso.",
  [LegacyMigrationMessages.legacyMigrationNotContracted]: "não contratado pelo cliente — não será liberado",
  [LegacyMigrationMessages.legacyMigrationIneligibleCount]:
    "{{count}} usuários não podem ser migrados — ver motivos",
  [LegacyMigrationMessages.legacyMigrationBack]: "Voltar",
  [LegacyMigrationMessages.legacyMigrationExportList]: "Exportar lista",
  [LegacyMigrationMessages.legacyMigrationExportListHint]:
    "Planilha com os usuários que podem ser migrados, para o cliente conferir antes da migração.",
  [LegacyMigrationMessages.legacyMigrationExportListEmail]: "E-mail",
  [LegacyMigrationMessages.legacyMigrationExportListStatus]: "Situação",
  [LegacyMigrationMessages.legacyMigrationExportListLockLegacy]: "Bloquear Legado",
  [LegacyMigrationMessages.legacyMigrationExportListNewLegacyPassword]: "Cadastrar nova senha no Legado",
  [LegacyMigrationMessages.legacyMigrationConfirm]: "Migrar {{count}} usuários",
  [LegacyMigrationMessages.legacyMigrationConfirmAction]: "Migrar agora",
  [LegacyMigrationMessages.legacyMigrationConfirmTitle]: "Confirmar a migração de {{tenant}}",
  [LegacyMigrationMessages.legacyMigrationConfirmBody]:
    "{{count}} usuários serão criados no Identity e poderão entrar pelo login da Topcon.",
  [LegacyMigrationMessages.legacyMigrationConfirmPasswords]:
    "{{count}} deles receberão um e-mail para criar a senha. Você pode rodar de novo depois sem duplicar ninguém.",

  [LegacyMigrationMessages.legacyMigrationMigratingTitle]: "Migrando os usuários de {{tenant}}",
  [LegacyMigrationMessages.legacyMigrationMigratingHint]:
    "Mantenha esta tela aberta até o fim. Se fechar, a migração para onde estiver — quem já foi migrado permanece no Identity.",
  [LegacyMigrationMessages.legacyMigrationProgress]: "{{done}} de {{count}} usuários",
  [LegacyMigrationMessages.legacyMigrationErrorsSoFar]: "{{count}} usuários com erro até agora",
  [LegacyMigrationMessages.legacyMigrationStop]: "Parar migração",
  [LegacyMigrationMessages.legacyMigrationStopping]: "Parando…",

  [LegacyMigrationMessages.legacyMigrationDoneTitle]: "Pronto! {{tenant}} foi migrado",
  [LegacyMigrationMessages.legacyMigrationDoneWithErrorsTitle]:
    "{{tenant}} foi migrado, mas alguns usuários falharam",
  [LegacyMigrationMessages.legacyMigrationStoppedTitle]: "A migração de {{tenant}} foi interrompida",
  [LegacyMigrationMessages.legacyMigrationDoneHint]:
    "Senhas mantidas: {{kept}} · E-mails de criação de senha enviados: {{reset}}.",
  [LegacyMigrationMessages.legacyMigrationStatCreated]: "criados",
  [LegacyMigrationMessages.legacyMigrationStatUpdated]: "atualizados",
  [LegacyMigrationMessages.legacyMigrationStatSkipped]: "sem mudança",
  [LegacyMigrationMessages.legacyMigrationStatErrors]: "erros",
  [LegacyMigrationMessages.legacyMigrationExport]: "Exportar CSV",
  [LegacyMigrationMessages.legacyMigrationRetry]: "Rodar novamente",

  // The plural forms i18next picks from the `count` option.
  [LegacyMigrationMessages.legacyMigrationReviewTitleZero]:
    "Nenhum usuário marcado — marque quem deve ser migrado",
  [LegacyMigrationMessages.legacyMigrationReviewTitleOne]:
    "{{count}} usuário de {{tenant}} será migrado",
  [LegacyMigrationMessages.legacyMigrationReviewTitleOther]:
    "{{count}} usuários de {{tenant}} serão migrados",
  [LegacyMigrationMessages.legacyMigrationIneligibleCountOne]:
    "1 usuário não pode ser migrado — ver motivo",
  [LegacyMigrationMessages.legacyMigrationIneligibleCountOther]:
    "{{count}} usuários não podem ser migrados — ver motivos",
  [LegacyMigrationMessages.legacyMigrationConfirmZero]:
    "Nenhum usuário marcado",
  [LegacyMigrationMessages.legacyMigrationConfirmOne]:
    "Migrar 1 usuário",
  [LegacyMigrationMessages.legacyMigrationConfirmOther]:
    "Migrar {{count}} usuários",
  [LegacyMigrationMessages.legacyMigrationConfirmBodyOne]:
    "1 usuário será criado no Identity e poderá entrar pelo login da Topcon.",
  [LegacyMigrationMessages.legacyMigrationConfirmBodyOther]:
    "{{count}} usuários serão criados no Identity e poderão entrar pelo login da Topcon.",
  [LegacyMigrationMessages.legacyMigrationConfirmPasswordsZero]:
    "Todos mantêm a senha do CRM antigo. Você pode rodar de novo depois sem duplicar ninguém.",
  [LegacyMigrationMessages.legacyMigrationConfirmPasswordsOne]:
    "1 deles receberá um e-mail para criar a senha. Você pode rodar de novo depois sem duplicar ninguém.",
  [LegacyMigrationMessages.legacyMigrationConfirmPasswordsOther]:
    "{{count}} deles receberão um e-mail para criar a senha. Você pode rodar de novo depois sem duplicar ninguém.",
  [LegacyMigrationMessages.legacyMigrationProgressOne]:
    "{{done}} de 1 usuário",
  [LegacyMigrationMessages.legacyMigrationProgressOther]:
    "{{done}} de {{count}} usuários",
  [LegacyMigrationMessages.legacyMigrationErrorsSoFarOne]:
    "1 usuário com erro até agora",
  [LegacyMigrationMessages.legacyMigrationErrorsSoFarOther]:
    "{{count}} usuários com erro até agora",

  [LegacyMigrationMessages.legacyMigrationOutcomeCreated]: "Criado",
  [LegacyMigrationMessages.legacyMigrationOutcomeUpdated]: "Atualizado",
  [LegacyMigrationMessages.legacyMigrationOutcomeSkipped]: "Sem mudança",
  [LegacyMigrationMessages.legacyMigrationOutcomeError]: "Erro",

  [LegacyMigrationMessages.legacyMigrationReasonNoEmail]: "Sem e-mail no cadastro do legado.",
  [LegacyMigrationMessages.legacyMigrationReasonNoAccessRows]: "Sem nenhum acesso cadastrado no legado.",
  [LegacyMigrationMessages.legacyMigrationReasonNoSsoAccess]: "Não possui direito no CRM.",
  [LegacyMigrationMessages.legacyMigrationReasonInOtherTenant]: "Já existe no Identity em outro cliente ({{detail}}).",
  [LegacyMigrationMessages.legacyMigrationReasonTopconStaff]: "Conta da equipe Topcon (@topconsuite.com): não é migrada.",
  [LegacyMigrationMessages.legacyMigrationReasonAlreadyProvisioned]: "Já existia no Identity com esses módulos.",
  [LegacyMigrationMessages.legacyMigrationReasonNoModulesSelected]: "Nenhum módulo selecionado.",
  [LegacyMigrationMessages.legacyMigrationReasonRemovedFromSource]:
    "Removido da base legada depois da revisão.",
  [LegacyMigrationMessages.legacyMigrationReasonEmailChanged]:
    "E-mail alterado na base legada depois da revisão (agora {{detail}}).",
  [LegacyMigrationMessages.legacyMigrationReasonResetEmailFailed]:
    "Conta criada, mas o e-mail de redefinição de senha não foi enviado.",
  [LegacyMigrationMessages.legacyMigrationReasonProvisionFailed]: "Falha ao provisionar: {{detail}}",
  [LegacyMigrationMessages.legacyMigrationReasonInvalidEmail]: "E-mail ausente ou inválido.",
  [LegacyMigrationMessages.legacyMigrationReasonNoValidModules]: "Nenhum módulo válido do Identity.",

  [LegacyMigrationMessages.legacyMigrationErrorForbidden]:
    "Você não tem acesso à migração do legado. Peça a quem gerencia o acesso.",
  [LegacyMigrationMessages.legacyMigrationErrorTenantNotFound]: "Cliente não encontrado.",
  [LegacyMigrationMessages.legacyMigrationErrorDataSourceNotConfigured]:
    "O registro das bases legadas não está configurado neste ambiente.",
  [LegacyMigrationMessages.legacyMigrationErrorDataSourceNotFound]:
    "Este cliente não tem base legada cadastrada.",
  [LegacyMigrationMessages.legacyMigrationErrorDataSourceUnavailable]:
    "Não foi possível acessar a base legada.",
  [LegacyMigrationMessages.legacyMigrationErrorModuleNotContracted]:
    "O cliente não contratou todos os módulos selecionados.",
  [LegacyMigrationMessages.legacyMigrationErrorInvalidRequest]: "Requisição inválida.",
  [LegacyMigrationMessages.legacyMigrationErrorUnknown]: "Não foi possível concluir a operação.",
  [LegacyMigrationMessages.legacyMigrationErrorDataSourceAccessDenied]:
    "O usuário do Identity não existe ou não tem permissão na base deste cliente.",

  [LegacyMigrationMessages.legacyMigrationColumnLegacy]: "Legado",
  [LegacyMigrationMessages.legacyMigrationLock]: "bloquear",
  [LegacyMigrationMessages.legacyMigrationLockAll]: "Bloquear o Topcon Legado de todos",
  [LegacyMigrationMessages.legacyMigrationAlsoUses]: "usa também: {{areas}}",
  [LegacyMigrationMessages.legacyMigrationAlreadyLocked]: "já bloqueado",
  [LegacyMigrationMessages.legacyMigrationReviewLockHint]:
    "Em \"Legado\", quem estiver marcado perde a senha do Topcon Legado e passa a entrar só pelo Identity.",
  [LegacyMigrationMessages.legacyMigrationConfirmLocks]:
    "{{count}} perderão a senha do Topcon Legado e passarão a entrar só pelo Identity. Para devolver o acesso, redefina a senha pelo Topcon Legado.",
  [LegacyMigrationMessages.legacyMigrationConfirmLocksOne]:
    "1 perderá a senha do Topcon Legado e passará a entrar só pelo Identity. Para devolver o acesso, redefina a senha pelo Topcon Legado.",
  [LegacyMigrationMessages.legacyMigrationConfirmLocksOther]:
    "{{count}} perderão a senha do Topcon Legado e passarão a entrar só pelo Identity. Para devolver o acesso, redefina a senha pelo Topcon Legado.",
  [LegacyMigrationMessages.legacyMigrationLockedSummary]: "Senhas do Topcon Legado bloqueadas: {{count}}.",
  [LegacyMigrationMessages.legacyMigrationLockFailed]:
    "{{count}} senhas do Topcon Legado não puderam ser bloqueadas — veja o motivo no CSV.",
  [LegacyMigrationMessages.legacyMigrationLockFailedOne]:
    "1 senha do Topcon Legado não pôde ser bloqueada — veja o motivo no CSV.",
  [LegacyMigrationMessages.legacyMigrationLockFailedOther]:
    "{{count}} senhas do Topcon Legado não puderam ser bloqueadas — veja o motivo no CSV.",

  [LegacyMigrationMessages.legacyMigrationLockReasonLocked]: "Senha do Topcon Legado bloqueada.",
  [LegacyMigrationMessages.legacyMigrationLockReasonAlreadyLocked]: "O Topcon Legado já estava bloqueado.",
  [LegacyMigrationMessages.legacyMigrationLockReasonSkippedPasswordNotKept]:
    "Não bloqueado: a senha do Topcon Legado não foi mantida, e o usuário ainda não tem senha no Topcon Suite.",
  [LegacyMigrationMessages.legacyMigrationLockReasonPasswordChanged]:
    "Não bloqueado: a senha foi alterada no Topcon Legado durante a migração.",
  [LegacyMigrationMessages.legacyMigrationLockReasonDenied]:
    "Não bloqueado: o usuário do Identity não tem permissão para alterar senhas nesta base.",
  [LegacyMigrationMessages.legacyMigrationLockReasonFailed]:
    "Não bloqueado: falha ao gravar no Topcon Legado ({{detail}}).",

  [LegacyMigrationMessages.legacyMigrationManageAccess]: "Gerenciar acesso",
  [LegacyMigrationMessages.legacyMigrationAccessTitle]: "Gerenciar acesso",
  [LegacyMigrationMessages.legacyMigrationAccessSubtitle]: "Admins que podem migrar clientes do Topcon Legado para o Identity.",
  [LegacyMigrationMessages.legacyMigrationAccessGrantLabel]: "Adicionar administrador",
  [LegacyMigrationMessages.legacyMigrationAccessGrant]: "Dar acesso",
  [LegacyMigrationMessages.legacyMigrationAccessRevoke]: "Remover acesso",
  [LegacyMigrationMessages.legacyMigrationAccessEmpty]: "Ninguém tem acesso ainda.",
  [LegacyMigrationMessages.legacyMigrationAccessGrantedBy]: "Concedido por {{name}} em {{date}}",
  [LegacyMigrationMessages.legacyMigrationAccessLoading]: "Carregando…",
  [LegacyMigrationMessages.legacyMigrationAccessLoadError]: "Não foi possível verificar o seu acesso.",
  [LegacyMigrationMessages.legacyMigrationTryAgain]: "Tentar novamente",

  [LegacyMigrationMessages.legacyMigrationSelectShown]: "Marcar os {{count}} filtrados",
  [LegacyMigrationMessages.legacyMigrationSelectShownOne]: "Marcar este",
  [LegacyMigrationMessages.legacyMigrationSelectShownOther]: "Marcar os {{count}} filtrados",
  [LegacyMigrationMessages.legacyMigrationClearShown]: "Desmarcar os {{count}} filtrados",
  [LegacyMigrationMessages.legacyMigrationClearShownOne]: "Desmarcar este",
  [LegacyMigrationMessages.legacyMigrationClearShownOther]: "Desmarcar os {{count}} filtrados",
  [LegacyMigrationMessages.legacyMigrationFilterAll]: "Todos",
  [LegacyMigrationMessages.legacyMigrationFilterLeftOut]: "Fora da migração",
  [LegacyMigrationMessages.legacyMigrationFilterOtherAreas]: "Usam outras áreas",
  [LegacyMigrationMessages.legacyMigrationFilterOnlyCrm]: "Só CRM",
  [LegacyMigrationMessages.legacyMigrationNoUsersFound]: "Nenhum usuário encontrado.",
  [LegacyMigrationMessages.legacyMigrationPageRange]: "{{from}}–{{to}} de {{total}}",
  [LegacyMigrationMessages.legacyMigrationPageNext]: "Próxima página",
  [LegacyMigrationMessages.legacyMigrationPagePrevious]: "Página anterior",
  [LegacyMigrationMessages.legacyMigrationPageGoTo]: "Ir para a página {{page}}",

  [LegacyMigrationMessages.legacyMigrationStaffErrorForbidden]: "Você não tem permissão para gerenciar este acesso.",
  [LegacyMigrationMessages.legacyMigrationStaffErrorUserNotFound]: "Usuário não encontrado.",
  [LegacyMigrationMessages.legacyMigrationStaffErrorTargetNotAdmin]: "Só administradores podem receber este acesso.",
  [LegacyMigrationMessages.legacyMigrationStaffErrorCannotRevokeSelf]: "Você não pode remover o seu próprio acesso.",

  [LegacyMigrationMessages.legacyMigrationStepResult]: "Resultado",
  [LegacyMigrationMessages.legacyMigrationInIdentity]: "já no Identity",
  [LegacyMigrationMessages.legacyMigrationInIdentityHint]: "Já existe no Identity. Migrar de novo só adiciona o que faltar.",
  [LegacyMigrationMessages.legacyMigrationFilterInIdentity]: "Já no Identity",
  [LegacyMigrationMessages.legacyMigrationSubtitle]:
    "Traga os usuários do CRM (TopSys) para o Identity. Rodar de novo é seguro: ninguém é duplicado.",
  [LegacyMigrationMessages.legacyMigrationChooseHint]: "{{count}} clientes. Na revisão, quem já está no Identity aparece identificado.",
  [LegacyMigrationMessages.legacyMigrationChooseHintZero]: "Nenhum cliente encontrado.",
  [LegacyMigrationMessages.legacyMigrationChooseHintOne]: "1 cliente. Na revisão, quem já está no Identity aparece identificado.",
  [LegacyMigrationMessages.legacyMigrationChooseHintOther]:
    "{{count}} clientes. Na revisão, quem já está no Identity aparece identificado.",
  [LegacyMigrationMessages.legacyMigrationReviewHint]:
    "Desmarque quem não deve ir; quem já está no Identity começa desmarcado. Quem tem no Topcon Legado uma senha dentro das "
    + "regras do Topcon Suite continua com ela, digitando em MAIÚSCULAS; os demais recebem um e-mail para criar uma nova.",
  [LegacyMigrationMessages.legacyMigrationLeave]: "Voltar ao início"
};
